import { render } from "./FileSend.vue?vue&type=template&id=31e776bd&scoped=true"
import script from "./FileSend.vue?vue&type=script&lang=js"
export * from "./FileSend.vue?vue&type=script&lang=js"

import "./FileSend.vue?vue&type=style&index=0&id=31e776bd&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e776bd"]])

export default __exports__